import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './zahlungen.module.scss';
import {zahlungenRun} from './zahlungen.route';
import {ZahlungenListViewComponentConfig} from './component/zahlungenListView';

export const SerfWebZahlungen = angular.module('serfWeb.zahlungen', [SerfWebCore.name])
    .component('zahlungenView', new ZahlungenListViewComponentConfig())
    .run(zahlungenRun);

export default SerfWebZahlungen;



// WEBPACK FOOTER //
// ./src/app/zahlungen/zahlungen.module.ts